export default __webpack_public_path__ + "static/media/menu_health.87caf358.svg";